<template>
  <div>
    <vuestic-modal
      :show.sync="modalInfo.show"
      v-bind:small="true"
      v-bind:force="true"
      ref="modalInfo"
      :cancelClass="'none'"
      :okText="'modal.close' | translate"
    >
      <div slot="title">{{ modalInfo.title }}</div>
      <div>{{ modalInfo.body }}</div>
    </vuestic-modal>

    <div class="form-wizard-page">
      <div class="row">
        <div class="col-md-12">
          <vuestic-widget class="no-h-padding" :headerText="$t('forms.wizard.rich')">
            <vuestic-wizard :steps="hrSteps" :lastStepLabel="$t('forms.wizard.confirm')" wizard-type="rich" ref="dnsForm">
              <div slot="page1" class="form-wizard-tab-content">
                <div class="form-wizard-tab-content-text">
                  <p>
                    <b>{{ $t('domain.step1') }}</b>
                  </p>
                </div>
                <vuestic-alert v-if="invalidDomain" type="danger">
                  <span class="badge badge-pill badge-danger">{{'domain.invalidDomain' | translate}}</span>
                  {{'domain.invalidDomainBody' | translate}}
                </vuestic-alert>
                <div
                  class="form-group with-icon-right"
                  :class="{'has-error': errors.has('hrName'), 'valid': isDomainValid('hrName')}"
                >
                  <div class="input-group">
                    <input
                      name="hrName"
                      data-vv-as="Name"
                      v-model="hrName"
                      v-validate="'required'"
                      required
                      title
                    >
                    <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                    <i class="fa fa-check valid-icon icon-right input-icon"></i>
                    <label class="control-label">
                      {{'domain.domainInput' |
                      translate}}
                    </label>
                    <i class="bar"></i>
                    <small
                      v-show="errors.has('hrName')"
                      class="help text-danger"
                    >{{ errors.first('hrName') }}</small>
                  </div>
                </div>
              </div>
              <div slot="page2" class="form-wizard-tab-content">
                <div class="form-wizard-tab-content-text">
                  <p>
                    <b>{{ $t('domain.step2') }}</b>
                  </p>
                </div>
                <vuestic-simple-select
                  :label="$t('domain.selectServer')"
                  v-model="vmSelected"
                  name="server"
                  :required="true"
                  ref="hrVmSelect"
                  option-key="name"
                  v-bind:options="vms"
                ></vuestic-simple-select>
              </div>
              <div slot="page3" class="form-wizard-tab-content">
                <h4>{{'domain.step3Title' | translate}}</h4>
                <p></p>
                <p>
                  <b>{{ $t('domain.step3') }}</b>
                </p>
                <ul class="vue-unordered">
                  <li>{{ $t('domain.ns1') }}</li>
                  <li>{{ $t('domain.ns2') }}</li>
                </ul>
              </div>
              <div slot="wizardCompleted" class="form-wizard-tab-content">
                <h4>{{'domain.step4Title' | translate}}</h4>
                <p>
                  <b>{{ $t('domain.step4') }}</b>
                </p>
                <ul class="vue-unordered">
                  <li>{{ $t('domain.ns1') }}</li>
                  <li>{{ $t('domain.ns2') }}</li>
                </ul>
                <p>{{ $t('domain.step4Bottom') }}</p>
              </div>
            </vuestic-wizard>
          </vuestic-widget>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget :headerText="$t('domain.domainList')">
          <vuestic-data-table
            ref="vmTable"
            :apiMode="apiMode"
            :tableData="tableData"
            :tableFields="tableFields"
            :itemsPerPage="itemsPerPage"
            :itemsPerPageLabel="$t('dashboard.perPage')"
            :onEachSide="onEachSide"
            :sortFunctions="sortFunctions"
            :dataModeFilterableFields="dataModeFilterableFields"
          />
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import BadgeColumn from 'components/tables/BadgeColumn.vue'
import FieldsDef from './fields-definition'
import CustomActions from './ManageAction'

import store from '../../store'
import ajax from 'services/ajax'

Vue.component('domain-custom-actions', CustomActions)
Vue.component('badge-column', BadgeColumn)

export default {
  name: 'domains',

  created () {
    store.commit('setLoading', true)
    let requestsFinished = 0

    ajax.run(
      this,
      'customer/domains',
      data => {
        this.tableData = {
          'data': data.domains
        }
        requestsFinished++
        this.stopLoadingAfter(requestsFinished)
      },
      error => {
        store.commit('setLoading', false)
        console.log(error)
      }
    )

    ajax.run(
      this,
      'customer/vms',
      data => {
        let instance = this
        data.forEach(function (vm) {
          vm.vm_nics.forEach(function (vmNic) {
            instance.vms.push(
              {
                'ip': vmNic.ip.ip_address,
                'name': 'vps' + vm.hosting_id + ' - ' + vmNic.ip.ip_address
              }
            )
          })
        })
        requestsFinished++
        this.stopLoadingAfter(requestsFinished)
      },
      error => {
        store.commit('setLoading', false)
        console.log(error)
      }
    )
  },
  computed: {
    hrSteps () {
      return [
        {
          label: this.$t('forms.wizard.stepOne'),
          slot: 'page1',
          onNext: async () => {
            this.validateFormField('hrName')
            // Query if domain exists
            store.commit('setLoading', true)
            await ajax.run(this, 'customer/domains/' + this.domainName, (data) => {
              store.commit('setLoading', false)
              if (data.exists) {
                this.modalInfo.title = this.$t('domain.domainAddErrorTitle')
                this.modalInfo.body = this.$t('domain.domainInUse')
                this.$refs.modalInfo.open()
                this.$refs.dnsForm.currentStep = 0
              }
            }, (error) => {
              store.commit('setLoading', false)
              this.modalInfo.title = this.$t('domain.domainAddErrorTitle')
              this.modalInfo.body = this.$t('domain.domainAddErrorBody')
              this.$refs.modalInfo.open()
              this.$refs.dnsForm.currentStep = 0
              console.log(error)
            })
          },
          isValid: () => {
            return this.isDomainValid('hrName')
          }
        },
        {
          label: this.$t('forms.wizard.stepTwo'),
          slot: 'page2',
          onNext: () => {
            this.$refs.hrVmSelect.validate()
          },
          isValid: () => {
            return this.$refs.hrVmSelect.isValid()
          }
        },
        {
          label: this.$t('forms.wizard.stepThree'),
          slot: 'page3',
          onNext: () => {
            this.createDnsZone()
          }
        }
      ]
    }
  },
  data () {
    return {
      hrName: '',

      modalInfo: {
        show: true,
        title: '',
        body: ''
      },
      invalidDomain: false,
      domainName: '',
      vms: [],
      vmSelected: '',

      tableData: {
        data: []
      },

      apiMode: false,
      sortFunctions: FieldsDef.sortFunctions,
      onEachSide: 1,
      tableFields: FieldsDef.tableFields,
      dataModeFilterableFields: ['domain'],
      itemsPerPage: [
        {
          value: 5
        },
        {
          value: 10
        }
      ]
    }
  },
  methods: {
    reloadDomainList () {
      ajax.run(
        this,
        'customer/domains',
        data => {
          this.tableData = {
            'data': data.domains
          }
        },
        error => {
          console.log(error)
        }
      )
    },
    createDnsZone () {
      console.log(this.domainName)
      console.log(this.vmSelected)
      store.commit('setLoading', true)
      ajax.run(this, 'customer/domains', (data) => {
        setTimeout(function () { store.commit('setLoading', false) }, 2000)
        this.showToast(this.$t('domain.domainAddSuccess'), {
          icon: 'fa-star-o',
          position: 'top-center',
          duration: 3000,
          fullWidth: false
        })
        this.reloadDomainList()
      }, (error) => {
        store.commit('setLoading', false)
        this.modalInfo.title = this.$t('domain.domainAddErrorTitle')
        this.modalInfo.body = this.$t('domain.domainAddErrorBody')
        this.$refs.modalInfo.open()
        this.$refs.dnsForm.currentStep = 0
        console.log(error)
      }, 'post',
        {
          'domain': this.domainName,
          'ip': this.vmSelected.ip
        })
    },
    stopLoadingAfter (counter) {
      if (counter >= 2) {
        store.commit('setLoading', false)
      }
    },
    extractDomain (text) {
      var matches = text.match(/[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/)
      if (matches) {
        return matches[0]
      } else {
        return ''
      }
    },
    isDomainValid (field) {
      let isValid = false
      let domainName = this.extractDomain(this[field])
      if (this.extractDomain(this[field]).length > 0) {
        isValid = true
        this.domainName = domainName
      }
      return isValid
    },
    isFormFieldValid (field) {
      let isValid = false
      if (this.formFields[field]) {
        isValid = this.formFields[field].validated && this.formFields[field].valid
      }
      return isValid
    },
    validateFormField (fieldName) {
      switch (fieldName) {
        case 'hrName':
          if (this.isDomainValid(fieldName) === false) {
            this.invalidDomain = true
          } else {
            this.invalidDomain = false
          }
          break
      }
      this.$validator.validate(fieldName, this[fieldName])
    }
  }
}
</script>

<style lang="scss">
@import "../../sass/_variables.scss";
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins/breakpoints";

.widget.simple-vertical-wizard-widget {
  .widget-body {
    padding: 0 $widget-padding;
    @include media-breakpoint-down(sm) {
      padding: $widget-padding 0;
    }
  }
}

.form-wizard-page {
  .form-group {
    min-width: 200px;
    max-width: 360px;
    width: 80%;
  }
}

.form-wizard-tab-content-text {
  width: 100%; // IE11 only
}
</style>



// WEBPACK FOOTER //
// src/components/domains/Domains.vue